module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配记录")])], 1)], 1), _vm._v(" "), (_vm.fromSalesDealRate) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBackSalesDealRate
    }
  }, [_vm._v("返回销售成交率")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("成交率分配明细，本周按公式筛选")])], 1) : (_vm.fromChannelDealRate) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-arrow-back"
    },
    on: {
      "click": _vm.goBackChannelDealRate
    }
  }, [_vm._v("返回渠道成交率")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("渠道成交率分配明细，本周按公式筛选")])], 1) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生:",
      "label-width": 70
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "学员状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.stdStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdStatus", $$v)
      },
      expression: "queryParam.stdStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("已预约")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已试听")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("付款未绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("已绑定")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("已开课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("已完课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("退费")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("不论")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "分配来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "不论"
    },
    model: {
      value: (_vm.queryParam.recordsSource),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "recordsSource", $$v)
      },
      expression: "queryParam.recordsSource"
    }
  }, _vm._l((_vm.$constant.recordsSource), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配时间:"
    }
  }, [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkStartTimeDate
    },
    on: {
      "on-change": _vm.linkTimeStartChange
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n            -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "value": _vm.queryParam.linkEndTimeDate
    },
    on: {
      "on-change": _vm.linkTimeEndChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "渠道分类"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.channelType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channelType", $$v)
      },
      expression: "queryParam.channelType"
    }
  }, _vm._l((this.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Col')], 1), _vm._v(" "), (!_vm.fromSalesDealRate && !_vm.fromChannelDealRate) ? _c('adviser-float-modal', {
    attrs: {
      "adviserId": _vm.queryParam.adviserId,
      "teamType": _vm.queryParam.teamType
    },
    on: {
      "get_adviser": _vm.getAdviserInfo
    }
  }) : _vm._e(), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.assignTitle,
      "listUrl": "/userinfo/distribution",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b79756","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/DistributionList.vue
// module id = 1838
// module chunks = 8